var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"name":_vm.name,"format":"dd-MM-yyyy","clear-button":true,"monday-first":true},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }